var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpFormPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 693,
    height: 543,
    viewBox: "0 0 693 543",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.031 543C537.139 543 692.062 537.011 692.062 529.623C692.062 522.234 537.139 516.245 346.031 516.245C154.923 516.245 0 522.234 0 529.623C0 537.011 154.923 543 346.031 543Z",
    fill: "url(#paint0_linear_37_2710)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M502.858 278.133L437.688 527.916C437.44 528.859 436.887 529.693 436.115 530.289C435.343 530.885 434.395 531.208 433.42 531.209C432.764 531.206 432.117 531.058 431.526 530.774C430.935 530.49 430.414 530.079 430.001 529.569C429.588 529.06 429.294 528.465 429.139 527.827C428.984 527.19 428.973 526.526 429.107 525.884L481.336 278.133H502.858Z",
    fill: "url(#paint1_linear_37_2710)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M589.914 278.133L655.084 527.916C655.329 528.86 655.882 529.697 656.654 530.293C657.427 530.889 658.376 531.211 659.352 531.209C660.008 531.206 660.655 531.058 661.246 530.774C661.838 530.49 662.359 530.079 662.771 529.569C663.184 529.06 663.479 528.465 663.633 527.827C663.788 527.19 663.799 526.526 663.666 525.884L611.427 278.133H589.914Z",
    fill: "url(#paint2_linear_37_2710)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M205.606 278.133L140.435 527.916C140.187 528.859 139.634 529.693 138.862 530.289C138.09 530.885 137.143 531.208 136.167 531.209C135.512 531.206 134.865 531.058 134.273 530.774C133.682 530.49 133.161 530.079 132.748 529.569C132.335 529.06 132.041 528.465 131.886 527.827C131.731 527.19 131.72 526.526 131.854 525.884L184.092 278.133H205.606Z",
    fill: "url(#paint3_linear_37_2710)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.58 278.133L334.75 527.916C334.998 528.859 335.551 529.693 336.323 530.289C337.095 530.885 338.043 531.208 339.018 531.209C339.676 531.213 340.326 531.069 340.921 530.788C341.516 530.506 342.04 530.095 342.454 529.583C342.869 529.072 343.163 528.474 343.314 527.834C343.466 527.193 343.472 526.527 343.332 525.884L291.102 278.133H269.58Z",
    fill: "url(#paint4_linear_37_2710)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M625.417 278.133H167.783C166.553 278.133 165.373 277.644 164.503 276.774C163.634 275.905 163.145 274.725 163.145 273.495C163.145 272.264 163.634 271.085 164.503 270.215C165.373 269.345 166.553 268.856 167.783 268.856H625.417C626.647 268.856 627.827 269.345 628.697 270.215C629.566 271.085 630.055 272.264 630.055 273.495C630.055 274.725 629.566 275.905 628.697 276.774C627.827 277.644 626.647 278.133 625.417 278.133Z",
    fill: "url(#paint5_linear_37_2710)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M625.417 268.847C626.647 268.847 627.827 269.335 628.697 270.205C629.566 271.075 630.055 272.255 630.055 273.485C630.055 274.715 629.566 275.895 628.697 276.765C627.827 277.635 626.647 278.124 625.417 278.124H470.732V268.847H625.417Z",
    fill: "url(#paint6_linear_37_2710)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M538.009 174.361H521.385V268.986H538.009V174.361Z",
    fill: "#85EF47"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M568.92 174.361H538.009V268.986H568.92V174.361Z",
    fill: "#00BD56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M532.183 188.165H527.099V242.779H532.183V188.165Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M529.641 255.182C531.045 255.182 532.183 254.044 532.183 252.64C532.183 251.236 531.045 250.098 529.641 250.098C528.237 250.098 527.099 251.236 527.099 252.64C527.099 254.044 528.237 255.182 529.641 255.182Z",
    fill: "#00BD56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M521.385 174.361H504.76V268.986H521.385V174.361Z",
    fill: "#5893D4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M515.559 188.165H510.475V242.779H515.559V188.165Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M513.017 255.182C514.421 255.182 515.559 254.044 515.559 252.64C515.559 251.236 514.421 250.098 513.017 250.098C511.613 250.098 510.475 251.236 510.475 252.64C510.475 254.044 511.613 255.182 513.017 255.182Z",
    fill: "#1F3C88"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M504.77 174.361H488.145V268.986H504.77V174.361Z",
    fill: "#FFD700"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M498.944 188.165H493.86V242.779H498.944V188.165Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M496.402 255.182C497.806 255.182 498.944 254.044 498.944 252.64C498.944 251.236 497.806 250.098 496.402 250.098C494.998 250.098 493.86 251.236 493.86 252.64C493.86 254.044 494.998 255.182 496.402 255.182Z",
    fill: "#C6A000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M433.569 246.805C432.271 246.803 431.002 247.186 429.922 247.906C428.843 248.625 428 249.649 427.503 250.847C427.005 252.045 426.874 253.364 427.126 254.637C427.378 255.91 428.002 257.08 428.918 257.998C429.835 258.916 431.004 259.542 432.277 259.796C433.549 260.049 434.868 259.92 436.067 259.424C437.266 258.928 438.291 258.087 439.012 257.008C439.733 255.93 440.118 254.661 440.118 253.364C440.118 251.626 439.429 249.959 438.201 248.729C436.973 247.499 435.307 246.807 433.569 246.805ZM433.569 255.98C433.049 255.981 432.541 255.829 432.108 255.542C431.675 255.254 431.337 254.845 431.137 254.365C430.936 253.886 430.883 253.358 430.983 252.848C431.084 252.338 431.333 251.869 431.7 251.501C432.067 251.133 432.534 250.882 433.044 250.78C433.553 250.678 434.082 250.729 434.562 250.928C435.042 251.126 435.453 251.463 435.742 251.895C436.031 252.327 436.185 252.835 436.185 253.354C436.185 254.048 435.909 254.714 435.419 255.204C434.928 255.695 434.263 255.97 433.569 255.97V255.98Z",
    fill: "url(#paint7_linear_37_2710)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M436.853 242.213H462.921C463.44 242.215 463.936 242.422 464.303 242.789C464.669 243.155 464.876 243.652 464.879 244.17V261.379C464.876 263.36 464.087 265.26 462.685 266.66C461.283 268.06 459.383 268.847 457.401 268.847H442.373C440.391 268.847 438.491 268.06 437.089 266.66C435.687 265.26 434.898 263.36 434.895 261.379V244.17C434.898 243.652 435.105 243.155 435.471 242.789C435.838 242.422 436.334 242.215 436.853 242.213Z",
    fill: "url(#paint8_linear_37_2710)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M375.04 463.404H378.575C378.575 458.537 380.508 453.87 383.949 450.428C387.391 446.987 392.058 445.054 396.925 445.054C401.791 445.054 406.459 446.987 409.9 450.428C413.341 453.87 415.275 458.537 415.275 463.404H418.818C418.7 457.676 416.342 452.223 412.25 448.215C408.158 444.206 402.658 441.961 396.929 441.961C391.201 441.961 385.7 444.206 381.608 448.215C377.516 452.223 375.158 457.676 375.04 463.404Z",
    fill: "#080957"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M453.755 458.097H351.3V531.209H453.755V458.097Z",
    fill: "#8AACFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M400.533 501.727H393.344C392.415 501.728 391.494 501.546 390.636 501.191C389.777 500.837 388.997 500.316 388.339 499.66C387.682 499.003 387.16 498.223 386.804 497.365C386.449 496.507 386.265 495.587 386.265 494.658H407.602C407.6 496.532 406.854 498.328 405.529 499.654C404.204 500.979 402.407 501.724 400.533 501.727Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M453.755 493.767H351.3V495.539H453.755V493.767Z",
    fill: "#080957"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M453.746 458.097H443.439V531.209H453.746V458.097Z",
    fill: "#080957"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M591.723 419.616C591.723 419.616 611.854 383.25 650.01 392.296C650.01 392.296 655.39 440.758 600.025 461.873C600.025 461.929 607.642 425.563 591.723 419.616Z",
    fill: "#461B93"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M599.293 437.428L615.991 422.585L618.338 409.81L619.201 409.977L617.067 421.629L628.33 411.638L630.686 398.771L631.558 398.929L629.406 410.683L641.466 399.995L642.05 400.654L624.34 416.369L636.53 418.605L636.373 419.468L623.496 417.111L610.332 428.8L622.485 431.036L622.327 431.908L609.497 429.552L599.886 438.087L599.293 437.428Z",
    fill: "#8253D7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M557.296 534.159H596.324C597.724 534.158 599.076 533.648 600.129 532.725C601.182 531.802 601.864 530.528 602.048 529.14L609.868 469.972C610.113 468.102 609.606 466.211 608.458 464.715C607.31 463.22 605.615 462.241 603.746 461.993C603.438 461.953 603.128 461.932 602.818 461.928H550.802C548.915 461.928 547.105 462.678 545.771 464.013C544.436 465.347 543.686 467.157 543.686 469.044C543.685 469.354 543.706 469.665 543.751 469.972L551.572 529.14C551.754 530.529 552.436 531.804 553.489 532.727C554.542 533.651 555.895 534.16 557.296 534.159Z",
    fill: "url(#paint9_linear_37_2710)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M598.55 461.928C598.55 461.928 624.637 437.762 603.412 422.724C582.186 407.686 594.932 398.845 605.137 385.616C615.342 372.387 591.917 362.182 599.432 345.382C606.946 328.581 578.206 313.098 573.79 340.075C569.374 367.053 590.888 369.521 576.815 393.641C562.741 417.761 582.928 446.278 576.815 461.901L598.55 461.928Z",
    fill: "#A393EB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M589.645 462.16C589.784 461.938 603.143 439.339 592.057 426.852C580.822 414.217 579.811 397.11 589.598 386.219C594.83 380.384 592.548 373.408 590.127 366.014C587.706 358.62 584.895 350.02 589.626 341.328L588.847 340.91C583.939 349.928 586.778 358.62 589.292 366.283C591.732 373.704 593.838 380.198 588.94 385.625C578.818 396.906 579.857 414.505 591.398 427.492C602.057 439.488 589.023 461.539 588.893 461.752L589.645 462.16Z",
    fill: "#5E63B6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M576.805 461.928C576.805 461.928 578.661 413.002 532.22 391.34C485.78 369.678 470.76 411.081 491.095 426.639C511.43 442.196 543.046 432.205 559.068 461.891L576.805 461.928Z",
    fill: "#FA67AB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M569.662 461.993L570.534 461.873C570.534 461.752 568.79 449.303 559.309 436.055C550.57 423.837 533.259 408.4 500.437 404.235L500.326 405.163C532.795 409.291 549.93 424.524 558.567 436.584C567.936 449.609 569.606 461.864 569.662 461.993Z",
    fill: "#FFD7F1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M248.901 238.186L465.352 239.114C470.76 239.114 475.148 233.835 475.148 228.427V85.5615C475.149 84.0907 474.861 82.6341 474.298 81.2751C473.736 79.916 472.911 78.6811 471.871 77.6411C470.831 76.6011 469.596 75.7764 468.237 75.2141C466.878 74.6518 465.422 74.363 463.951 74.3642H250.673C248.213 74.3642 245.853 75.3416 244.113 77.0814C242.374 78.8212 241.396 81.1808 241.396 83.6412V230.672C241.396 231.659 241.591 232.636 241.968 233.548C242.346 234.459 242.899 235.288 243.597 235.985C244.295 236.683 245.123 237.237 246.035 237.614C246.947 237.992 247.924 238.186 248.911 238.186H248.901Z",
    fill: "url(#paint10_linear_37_2710)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M468.07 228.39C468.07 233.668 463.895 238.789 458.672 239.049L270.405 238.279L248.901 238.186C246.908 238.186 244.997 237.395 243.588 235.985C242.179 234.576 241.387 232.665 241.387 230.672V214.307H468.07V228.39Z",
    fill: "#F0F0F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M354.724 232.444C357.9 232.444 360.475 229.869 360.475 226.692C360.475 223.516 357.9 220.941 354.724 220.941C351.547 220.941 348.972 223.516 348.972 226.692C348.972 229.869 351.547 232.444 354.724 232.444Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M395.023 238.808L397.212 257.659C397.365 258.968 397.258 260.295 396.897 261.564C396.537 262.832 395.93 264.017 395.112 265.051C394.294 266.085 393.279 266.947 392.128 267.589C390.976 268.231 389.709 268.639 388.399 268.791C388.014 268.839 387.627 268.864 387.239 268.865H310.899C310.899 266.754 311.738 264.73 313.231 263.237C314.723 261.744 316.748 260.906 318.859 260.906H346.096C348.379 260.903 350.567 259.995 352.181 258.381C353.795 256.767 354.703 254.579 354.705 252.297V238.632L395.023 238.808Z",
    fill: "url(#paint11_linear_37_2710)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M310.909 268.847H387.239C388.558 268.848 389.864 268.589 391.082 268.085C392.301 267.581 393.408 266.842 394.34 265.91C395.272 264.977 396.012 263.87 396.516 262.652C397.02 261.433 397.278 260.128 397.277 258.809C397.277 258.429 397.277 258.039 397.212 257.659L397.138 257.065C396.769 259.425 395.568 261.575 393.753 263.128C391.938 264.681 389.628 265.535 387.239 265.535H311.632C311.148 266.572 310.901 267.703 310.909 268.847Z",
    fill: "url(#paint12_linear_37_2710)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M389.92 238.762L392.11 257.659C392.262 258.969 392.155 260.297 391.794 261.566C391.433 262.835 390.826 264.02 390.006 265.054C389.187 266.088 388.172 266.95 387.019 267.591C385.866 268.232 384.598 268.64 383.287 268.791C382.903 268.836 382.515 268.858 382.128 268.856H387.239C388.558 268.857 389.864 268.598 391.082 268.094C392.301 267.59 393.408 266.851 394.34 265.919C395.272 264.986 396.012 263.879 396.516 262.661C397.02 261.443 397.278 260.137 397.277 258.818C397.277 258.438 397.277 258.048 397.212 257.668L395.023 238.817L389.92 238.762Z",
    fill: "#866EC7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M363.658 268.847H239.392V260.887H355.689C357.8 260.887 359.824 261.726 361.317 263.218C362.81 264.711 363.648 266.736 363.648 268.847H363.658Z",
    fill: "url(#paint13_linear_37_2710)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M458.283 239.068H465.361C470.769 239.068 475.157 233.798 475.157 228.39V85.5244C475.159 84.0532 474.87 82.5962 474.308 81.2366C473.746 79.877 472.921 78.6415 471.881 77.6007C470.841 76.56 469.606 75.7344 468.247 75.1711C466.888 74.6078 465.431 74.3179 463.96 74.3179H456.882C458.353 74.3166 459.809 74.6054 461.168 75.1677C462.527 75.73 463.762 76.5547 464.802 77.5947C465.842 78.6348 466.667 79.8696 467.229 81.2287C467.792 82.5878 468.08 84.0444 468.079 85.5152V228.381C468.07 233.798 463.691 239.068 458.283 239.068Z",
    fill: "#866EC7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M465.352 239.068H458.283C463.7 239.068 468.079 233.798 468.079 228.39V214.307L475.157 213.575V228.418C475.148 233.798 470.76 239.068 465.352 239.068Z",
    fill: "url(#paint14_linear_37_2710)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M402.955 54.1033C402.961 57.664 404.38 61.0765 406.901 63.591C409.423 66.1055 412.839 67.5163 416.399 67.5132C419.96 67.5101 423.374 66.0935 425.89 63.5747C428.407 61.0558 429.821 57.6408 429.821 54.0801C429.821 50.5195 428.407 47.1045 425.89 44.5856C423.374 42.0668 419.96 40.6502 416.399 40.6471C412.839 40.644 409.423 42.0547 406.901 44.5692C404.38 47.0837 402.961 50.4963 402.955 54.0569V54.1033Z",
    fill: "url(#paint15_linear_37_2710)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M412.825 48.7598C412.825 49.4644 413.034 50.1531 413.426 50.7389C413.817 51.3248 414.374 51.7814 415.025 52.051C415.675 52.3206 416.392 52.3912 417.083 52.2537C417.774 52.1162 418.409 51.777 418.907 51.2788C419.405 50.7806 419.744 50.1458 419.882 49.4548C420.019 48.7637 419.949 48.0475 419.679 47.3965C419.409 46.7456 418.953 46.1892 418.367 45.7978C417.781 45.4064 417.092 45.1974 416.388 45.1974C415.443 45.1974 414.537 45.5727 413.869 46.2408C413.201 46.9089 412.825 47.815 412.825 48.7598Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M407.361 64.0575C409.84 66.3007 413.063 67.5428 416.406 67.5428C419.749 67.5428 422.973 66.3007 425.451 64.0575C424.264 58.547 420.655 54.5579 416.406 54.5579C412.157 54.5579 408.558 58.547 407.361 64.0575Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M289.803 78.5945C299.492 78.5945 307.346 70.7404 307.346 61.0518C307.346 51.3632 299.492 43.509 289.803 43.509C280.115 43.509 272.261 51.3632 272.261 61.0518C272.261 70.7404 280.115 78.5945 289.803 78.5945Z",
    fill: "url(#paint16_linear_37_2710)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M282.688 62.2114V66.8499C282.688 67.9202 283.113 68.9466 283.87 69.7034C284.627 70.4602 285.653 70.8854 286.724 70.8854H292.883C293.954 70.8854 294.98 70.4602 295.737 69.7034C296.494 68.9466 296.919 67.9202 296.919 66.8499V62.2114C296.915 61.5136 296.729 60.8289 296.381 60.224C296.034 59.6192 295.535 59.1149 294.934 58.7604V55.9587C294.943 55.285 294.819 54.6161 294.57 53.9902C294.32 53.3643 293.95 52.7936 293.48 52.3108C293.01 51.8279 292.45 51.4424 291.831 51.1761C291.212 50.9099 290.547 50.7681 289.873 50.759C289.199 50.7499 288.53 50.8735 287.905 51.1229C287.279 51.3722 286.708 51.7425 286.225 52.2124C285.742 52.6823 285.357 53.2427 285.09 53.8616C284.824 54.4806 284.682 55.1459 284.673 55.8196C284.664 55.8655 284.664 55.9128 284.673 55.9587V58.7418C284.067 59.0951 283.564 59.6017 283.216 60.2107C282.867 60.8197 282.685 61.5097 282.688 62.2114ZM287.818 63.6957C287.818 63.1692 288.027 62.6642 288.4 62.2919C288.772 61.9196 289.277 61.7105 289.803 61.7105C290.33 61.7105 290.835 61.9196 291.207 62.2919C291.58 62.6642 291.789 63.1692 291.789 63.6957C291.78 64.1066 291.646 64.5049 291.404 64.8368C291.162 65.1687 290.823 65.418 290.434 65.5511V66.7015C290.434 66.8688 290.368 67.0292 290.25 67.1475C290.131 67.2658 289.971 67.3323 289.803 67.3323C289.636 67.3323 289.476 67.2658 289.357 67.1475C289.239 67.0292 289.173 66.8688 289.173 66.7015V65.5419C288.781 65.4135 288.439 65.1654 288.196 64.8324C287.953 64.4995 287.821 64.0986 287.818 63.6865V63.6957ZM286.724 58.1852C286.362 58.1862 286.003 58.2393 285.657 58.3429V55.9587C285.657 54.8589 286.094 53.8042 286.871 53.0265C287.649 52.2488 288.704 51.8119 289.803 51.8119C290.903 51.8119 291.958 52.2488 292.736 53.0265C293.513 53.8042 293.95 54.8589 293.95 55.9587V58.38C293.604 58.2764 293.245 58.2233 292.883 58.2223L286.724 58.1852Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M338.025 48.7505C349.215 48.7505 358.286 39.6794 358.286 28.4896C358.286 17.2998 349.215 8.22868 338.025 8.22868C326.835 8.22868 317.764 17.2998 317.764 28.4896C317.764 39.6794 326.835 48.7505 338.025 48.7505Z",
    fill: "url(#paint17_linear_37_2710)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M349.519 20.0012H326.54V36.9873H349.519V20.0012Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M326.55 20.0012L335.687 28.4803C336.327 29.0704 337.165 29.398 338.034 29.398C338.904 29.398 339.742 29.0704 340.382 28.4803L349.529 20.0012H326.55Z",
    fill: "#CDD9FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M340.075 28.805L349.519 36.9873L340.678 28.1278L340.075 28.805Z",
    fill: "#CDD9FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M335.381 28.1278L326.55 36.9873L335.994 28.805L335.381 28.1278Z",
    fill: "#CDD9FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M389.698 25.6416C396.779 25.6416 402.519 19.9015 402.519 12.8208C402.519 5.74006 396.779 0 389.698 0C382.617 0 376.877 5.74006 376.877 12.8208C376.877 19.9015 382.617 25.6416 389.698 25.6416Z",
    fill: "url(#paint18_linear_37_2710)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M387.509 18.1829C387.336 18.1824 387.165 18.1477 387.006 18.0808C386.847 18.0139 386.702 17.9162 386.581 17.7932L382.87 14.0824C382.617 13.8364 382.471 13.4998 382.466 13.1466C382.461 12.7934 382.596 12.4526 382.842 12.1992C383.088 11.9458 383.425 11.8005 383.778 11.7953C384.131 11.7901 384.472 11.9254 384.725 12.1714L387.462 14.9545L394.587 7.82049C394.833 7.56707 395.17 7.42177 395.523 7.41655C395.876 7.41133 396.217 7.54662 396.47 7.79266C396.724 8.0387 396.869 8.37533 396.874 8.7285C396.879 9.08168 396.744 9.42246 396.498 9.67588L388.427 17.7469C388.189 18.0059 387.86 18.1623 387.509 18.1829Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M385.755 86.2202C386.975 86.2202 387.963 85.2317 387.963 84.0123C387.963 82.7929 386.975 81.8044 385.755 81.8044C384.536 81.8044 383.547 82.7929 383.547 84.0123C383.547 85.2317 384.536 86.2202 385.755 86.2202Z",
    fill: "url(#paint19_linear_37_2710)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M374.484 68.9558C376.928 68.9558 378.909 66.9746 378.909 64.5306C378.909 62.0867 376.928 60.1055 374.484 60.1055C372.04 60.1055 370.059 62.0867 370.059 64.5306C370.059 66.9746 372.04 68.9558 374.484 68.9558Z",
    fill: "url(#paint20_linear_37_2710)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M373.157 48.2959C374.868 48.2959 376.256 46.9087 376.256 45.1974C376.256 43.4862 374.868 42.0989 373.157 42.0989C371.446 42.0989 370.059 43.4862 370.059 45.1974C370.059 46.9087 371.446 48.2959 373.157 48.2959Z",
    fill: "url(#paint21_linear_37_2710)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M391.062 67.0262C391.815 67.0262 392.425 66.4156 392.425 65.6624C392.425 64.9093 391.815 64.2987 391.062 64.2987C390.308 64.2987 389.698 64.9093 389.698 65.6624C389.698 66.4156 390.308 67.0262 391.062 67.0262Z",
    fill: "url(#paint22_linear_37_2710)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M329.824 72.648C330.803 72.648 331.596 71.8547 331.596 70.8761C331.596 69.8975 330.803 69.1042 329.824 69.1042C328.846 69.1042 328.052 69.8975 328.052 70.8761C328.052 71.8547 328.846 72.648 329.824 72.648Z",
    fill: "url(#paint23_linear_37_2710)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M314.656 67.1746C315.445 67.1746 316.085 66.535 316.085 65.7459C316.085 64.9569 315.445 64.3173 314.656 64.3173C313.867 64.3173 313.228 64.9569 313.228 65.7459C313.228 66.535 313.867 67.1746 314.656 67.1746Z",
    fill: "url(#paint24_linear_37_2710)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M351.161 67.3045C352.068 67.3045 352.803 66.5693 352.803 65.6624C352.803 64.7556 352.068 64.0204 351.161 64.0204C350.254 64.0204 349.519 64.7556 349.519 65.6624C349.519 66.5693 350.254 67.3045 351.161 67.3045Z",
    fill: "url(#paint25_linear_37_2710)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M352.813 84.773C353.72 84.773 354.455 84.0379 354.455 83.131C354.455 82.2241 353.72 81.489 352.813 81.489C351.906 81.489 351.171 82.2241 351.171 83.131C351.171 84.0379 351.906 84.773 352.813 84.773Z",
    fill: "url(#paint26_linear_37_2710)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M321.085 59.7901C322.617 59.7901 323.859 58.5482 323.859 57.0163C323.859 55.4844 322.617 54.2425 321.085 54.2425C319.553 54.2425 318.312 55.4844 318.312 57.0163C318.312 58.5482 319.553 59.7901 321.085 59.7901Z",
    fill: "url(#paint27_linear_37_2710)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M361.218 52.8788C361.827 52.8788 362.322 52.3845 362.322 51.7748C362.322 51.1651 361.827 50.6708 361.218 50.6708C360.608 50.6708 360.114 51.1651 360.114 51.7748C360.114 52.3845 360.608 52.8788 361.218 52.8788Z",
    fill: "url(#paint28_linear_37_2710)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M397.917 38.7592C398.896 38.7592 399.689 37.9659 399.689 36.9873C399.689 36.0087 398.896 35.2154 397.917 35.2154C396.939 35.2154 396.145 36.0087 396.145 36.9873C396.145 37.9659 396.939 38.7592 397.917 38.7592Z",
    fill: "url(#paint29_linear_37_2710)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M210.133 494.806C210.133 494.806 213.677 489.713 225.171 503.647C233.028 513.165 244.652 506.3 249.495 510.725C250.913 512.117 251.852 513.923 252.176 515.883C252.377 516.901 252.376 517.948 252.173 518.964C251.969 519.981 251.567 520.948 250.99 521.809C250.413 522.671 249.672 523.41 248.809 523.985C247.946 524.56 246.978 524.959 245.961 525.16C245.448 525.266 244.925 525.315 244.402 525.309H227.991C224.18 525.383 220.393 524.685 216.859 523.259C215.754 522.799 214.567 522.571 213.371 522.591H205.485C203.721 522.694 202.032 523.342 200.652 524.446C198.955 525.732 196.922 526.499 194.798 526.654C192.237 526.806 189.668 526.743 187.117 526.468C185.719 526.392 184.345 526.078 183.053 525.541C182.096 525.022 181.272 524.288 180.647 523.396C180.022 522.504 179.614 521.479 179.454 520.401C178.619 515.661 176.17 508.388 178.805 499.157C179.158 497.923 179.905 496.839 180.932 496.069C181.958 495.298 183.208 494.884 184.491 494.89L210.133 494.806Z",
    fill: "#151130"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M210.133 494.806C210.133 494.806 212.461 494.806 214.771 499.222C217.323 504.074 210.281 506.449 199.817 505.41C189.352 504.371 183.378 494.806 183.378 494.806H210.133Z",
    fill: "#FFB192"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M161.791 313.951L269.858 315.807C274.901 315.892 279.704 317.977 283.211 321.602C286.718 325.227 288.642 330.097 288.56 335.14C288.533 336.41 288.384 337.674 288.115 338.916L253.79 494.843H227.453L239.346 370.124C239.378 369.79 239.344 369.453 239.245 369.132C239.147 368.811 238.986 368.513 238.773 368.255C238.559 367.996 238.297 367.783 238 367.626C237.704 367.469 237.379 367.372 237.045 367.34C236.876 367.322 236.705 367.322 236.535 367.34C220.43 368.982 146.159 376.506 119.812 378.074C90.1815 379.846 78.2513 313.961 78.2513 313.961L161.791 313.951Z",
    fill: "url(#paint30_linear_37_2710)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M236.507 367.331L210.133 494.806H183.397L192.423 371.719L236.507 367.331Z",
    fill: "url(#paint31_linear_37_2710)",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M253.762 494.806C253.762 494.806 257.742 489.713 269.246 503.647C277.094 513.165 288.727 506.3 293.561 510.725C294.979 512.117 295.917 513.923 296.242 515.883C296.444 516.9 296.444 517.947 296.242 518.963C296.04 519.98 295.639 520.947 295.062 521.809C294.486 522.67 293.745 523.41 292.883 523.985C292.02 524.56 291.052 524.96 290.035 525.16C289.52 525.265 288.994 525.315 288.468 525.309H271.509C267.823 525.31 264.171 524.595 260.757 523.203C259.712 522.775 258.593 522.555 257.464 522.554H249.551C248.086 522.552 246.645 522.92 245.361 523.624C244.076 524.328 242.99 525.345 242.203 526.58H231.043C229.257 526.582 227.528 525.955 226.157 524.811C224.787 523.666 223.863 522.075 223.547 520.318C222.62 514.872 222.508 506.078 227.453 494.797L253.762 494.806Z",
    fill: "#352961"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M253.762 494.806C253.762 494.806 256.546 494.806 258.846 499.222C261.397 504.074 254.356 506.449 243.892 505.41C233.427 504.371 227.453 494.806 227.453 494.806H253.762Z",
    fill: "#FFB192"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M165.325 147.467C165.325 147.467 184.12 159.777 193.295 164.787C202.47 169.796 221.339 245.562 226.052 246.424C230.765 247.287 268.058 246.87 268.058 246.87L277.205 258.067C277.205 258.067 234.605 272.075 214.855 274.765C195.104 277.456 176.819 217.128 176.819 217.128C176.819 217.128 180.335 246.313 170.622 257.074C160 268.856 159.249 299.498 161.781 313.97C161.781 313.97 123.31 329.147 78.2142 313.97C78.2142 313.97 76.4423 225.533 78.2142 197.674C79.9861 169.815 92.7976 146.381 129.943 143.951L165.325 147.467Z",
    fill: "url(#paint32_linear_37_2710)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2235 313.951C78.2235 313.951 77.9452 300.481 77.7225 282.41L133.041 274.765L141.159 230.236L161.568 206.181C161.568 206.181 172.422 220.801 168.702 232.314C164.982 243.827 149.721 251.749 153.256 263.54C156.79 275.331 142.077 286.093 148.84 298.45C155.603 310.807 161.828 313.951 161.828 313.951C161.828 313.951 123.319 329.129 78.2235 313.951Z",
    fill: "url(#paint33_linear_37_2710)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M168.683 189.696L176.828 217.109L177.079 219.734C177.543 225.495 178.192 239.587 174.695 249.699C176.745 241.146 168.683 189.696 168.683 189.696Z",
    fill: "url(#paint34_linear_37_2710)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M277.196 258.085C281.307 258.047 285.409 257.706 289.47 257.065C293.997 256.137 295.769 259.004 298.533 259.004C301.298 259.004 297.754 253.15 289.136 249.727C280.517 246.304 269.005 248.066 269.005 248.066L277.196 258.085Z",
    fill: "#FFB192"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M169.527 134.869C170.78 137.197 172.385 140.008 173.971 143.116C179.018 143.867 185.382 143.728 187.655 139.071C190.865 132.457 192.562 108.791 193.11 99.9037C192.423 100.303 191.764 100.646 191.106 100.952C189.135 101.809 186.991 102.193 184.846 102.073C182.7 101.954 180.612 101.335 178.749 100.266C176.819 99.2172 174.416 98.9204 173.136 102.585C170.789 109.376 177.116 109.812 175.789 112.91C174.463 116.009 163.117 122.929 169.527 134.869Z",
    fill: "#FFB192"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M191.106 100.952C189.134 101.808 186.989 102.192 184.843 102.075C182.696 101.957 180.606 101.341 178.74 100.275C176.81 99.2172 174.407 98.9111 173.127 102.585C170.771 109.366 177.107 109.812 175.78 112.901C174.454 115.99 163.108 122.92 169.518 134.869C175.929 146.817 191.848 171.568 164.434 183.944C137.021 196.319 177.701 208.713 167.969 229.939C158.237 251.165 140.556 242.76 145.417 260.887C150.278 279.014 144.981 292.28 118.003 297.151C91.0257 302.021 73.3438 293.607 63.1762 266.194C53.0087 238.78 75.1157 242.315 71.1359 202.08C67.1561 161.846 93.6882 150.343 108.244 142.828C122.799 135.314 112.66 125.044 116.203 96.7496C119.747 68.4548 138.014 58.3707 152.458 58.3707C166.902 58.3707 187.098 77.3885 199.325 80.3293C211.552 83.2701 203.036 91.9812 197.117 97.0279C195.303 98.6059 193.28 99.9263 191.106 100.952Z",
    fill: "url(#paint35_linear_37_2710)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M149.999 385.291L143.969 528.704C143.948 529.219 143.729 529.707 143.357 530.064C142.986 530.422 142.491 530.623 141.975 530.624C141.458 530.625 140.96 530.425 140.587 530.067C140.213 529.71 139.993 529.221 139.971 528.704L133.932 385.291H149.999Z",
    fill: "url(#paint36_linear_37_2710)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M209.947 385.291L242.231 526.58C242.347 527.064 242.351 527.568 242.242 528.053C242.134 528.539 241.916 528.994 241.606 529.383C241.296 529.772 240.901 530.085 240.451 530.299C240.002 530.512 239.51 530.62 239.012 530.615C238.291 530.621 237.589 530.388 237.013 529.954C236.438 529.52 236.022 528.907 235.83 528.212L195.401 385.291H209.947Z",
    fill: "url(#paint37_linear_37_2710)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1983 384.364L27.7289 526.58C27.5372 527.434 27.6909 528.33 28.1565 529.072C28.6222 529.814 29.3621 530.342 30.2151 530.541C30.4596 530.589 30.7081 530.614 30.9573 530.615C31.6771 530.616 32.3774 530.382 32.9518 529.948C33.5262 529.514 33.9432 528.905 34.1393 528.212L74.5591 384.364H60.1983Z",
    fill: "#866EC7"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M124.868 242.983H29.5751L31.347 351.171C31.347 370.012 44.8543 385.291 63.7051 385.291H222.889C223.728 385.291 224.532 384.958 225.126 384.365C225.719 383.772 226.052 382.967 226.052 382.128C226.052 381.289 225.719 380.484 225.126 379.891C224.532 379.298 223.728 378.964 222.889 378.964H153.896C148.253 378.963 142.823 376.808 138.715 372.939C134.606 369.07 132.129 363.78 131.789 358.147L124.868 242.983Z",
    fill: "url(#paint38_linear_37_2710)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M125.239 357.878L116.686 242.983H124.868L131.789 358.138C132.127 363.771 134.603 369.063 138.712 372.932C142.821 376.802 148.252 378.956 153.896 378.955H222.889C223.699 378.999 224.462 379.352 225.02 379.941C225.579 380.531 225.89 381.312 225.89 382.123C225.89 382.935 225.579 383.716 225.02 384.305C224.462 384.895 223.699 385.247 222.889 385.291H151.966C136.798 385.291 126.167 373.018 125.239 357.878Z",
    fill: "#FFEEF6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M127.818 385.291L116.89 527.572C116.854 527.945 116.894 528.32 117.007 528.677C117.12 529.033 117.304 529.364 117.547 529.648C117.79 529.932 118.088 530.164 118.423 530.33C118.758 530.496 119.123 530.593 119.497 530.615H119.71C120.396 530.607 121.056 530.351 121.568 529.894C122.079 529.437 122.408 528.81 122.493 528.129L140.064 385.263L127.818 385.291Z",
    fill: "url(#paint39_linear_37_2710)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M461.001 81.3591H248.456V207.238H461.001V81.3591Z",
    fill: "#F0F0F0"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M402.955 207.238H306.474V99.208C306.474 97.0551 307.329 94.9905 308.852 93.4682C310.374 91.9459 312.439 91.0906 314.591 91.0906H394.828C396.981 91.0906 399.046 91.9459 400.568 93.4682C402.09 94.9905 402.945 97.0551 402.945 99.208L402.955 207.238Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M341.272 115.944C341.272 118.604 342.061 121.204 343.539 123.416C345.016 125.628 347.117 127.352 349.574 128.37C352.031 129.389 354.736 129.656 357.345 129.137C359.954 128.619 362.351 127.339 364.232 125.459C366.114 123.578 367.396 121.182 367.916 118.574C368.436 115.965 368.171 113.26 367.154 110.802C366.138 108.344 364.415 106.243 362.204 104.764C359.993 103.284 357.393 102.494 354.733 102.492C352.966 102.491 351.216 102.838 349.583 103.513C347.95 104.189 346.465 105.179 345.215 106.429C343.965 107.678 342.974 109.161 342.297 110.794C341.62 112.426 341.272 114.176 341.272 115.944Z",
    fill: "url(#paint40_linear_37_2710)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M351.161 110.609C351.16 111.316 351.368 112.008 351.759 112.596C352.15 113.185 352.707 113.644 353.36 113.916C354.012 114.188 354.731 114.26 355.424 114.123C356.118 113.986 356.755 113.647 357.255 113.147C357.756 112.648 358.097 112.012 358.235 111.319C358.374 110.626 358.304 109.907 358.034 109.254C357.764 108.601 357.306 108.042 356.718 107.65C356.131 107.257 355.44 107.047 354.733 107.047C353.789 107.047 352.883 107.421 352.214 108.087C351.545 108.752 351.166 109.656 351.161 110.6V110.609Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M345.688 125.907C348.165 128.15 351.387 129.391 354.728 129.391C358.07 129.391 361.292 128.15 363.769 125.907C362.581 120.406 358.982 116.407 354.733 116.407C350.484 116.407 346.875 120.406 345.688 125.907Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M376.998 145.185C376.998 146.02 376.669 146.821 376.082 147.415C375.495 148.009 374.697 148.348 373.862 148.357H324.694C323.854 148.355 323.05 148.02 322.457 147.425C321.864 146.83 321.531 146.025 321.531 145.185C321.531 144.345 321.864 143.539 322.457 142.945C323.05 142.35 323.854 142.014 324.694 142.012H373.862C374.697 142.022 375.495 142.36 376.082 142.954C376.669 143.548 376.998 144.35 376.998 145.185Z",
    fill: "#F0F0F0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M387.945 145.185C387.945 146.025 387.612 146.83 387.019 147.425C386.426 148.02 385.621 148.355 384.781 148.357C384.365 148.357 383.952 148.275 383.567 148.116C383.182 147.956 382.832 147.723 382.538 147.428C382.243 147.134 382.009 146.784 381.85 146.399C381.691 146.014 381.609 145.601 381.609 145.185C381.609 144.343 381.943 143.536 382.538 142.941C383.133 142.346 383.94 142.012 384.781 142.012C385.621 142.014 386.426 142.35 387.019 142.945C387.612 143.539 387.945 144.345 387.945 145.185Z",
    fill: "#F0F0F0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M387.945 156.679C387.945 157.519 387.612 158.324 387.019 158.919C386.426 159.514 385.621 159.849 384.781 159.852C383.94 159.852 383.133 159.517 382.538 158.922C381.943 158.327 381.609 157.52 381.609 156.679C381.611 155.839 381.946 155.034 382.541 154.441C383.136 153.848 383.941 153.515 384.781 153.515C385.62 153.515 386.425 153.849 387.018 154.442C387.611 155.035 387.945 155.84 387.945 156.679Z",
    fill: "#F0F0F0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M376.998 156.679C377 157.516 376.672 158.319 376.085 158.915C375.498 159.511 374.699 159.851 373.862 159.861H324.694C323.854 159.858 323.05 159.523 322.457 158.928C321.864 158.334 321.531 157.528 321.531 156.688C321.531 155.849 321.864 155.045 322.457 154.451C323.051 153.858 323.855 153.525 324.694 153.525H373.862C374.695 153.532 375.491 153.867 376.078 154.458C376.665 155.048 376.995 155.846 376.998 156.679Z",
    fill: "#F0F0F0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M362.804 178.452H346.106C343.031 178.452 340.539 180.944 340.539 184.018C340.539 187.092 343.031 189.584 346.106 189.584H362.804C365.878 189.584 368.37 187.092 368.37 184.018C368.37 180.944 365.878 178.452 362.804 178.452Z",
    fill: "#F0F0F0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_2710",
    x1: 345.099,
    y1: 382.471,
    x2: 345.099,
    y2: 567.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#866EC7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37_2710",
    x1: 470.372,
    y1: 576.058,
    x2: 381.558,
    y2: 265.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_37_2710",
    x1: 52515.1,
    y1: -52874400,
    x2: 6643.5,
    y2: -52921200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_37_2710",
    x1: 16521.9,
    y1: -52822600,
    x2: -17533.4,
    y2: -52839800,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_37_2710",
    x1: 27046.1,
    y1: -52862600,
    x2: -7454.23,
    y2: -52880300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_37_2710",
    x1: -70.3149,
    y1: 273.49,
    x2: 536.68,
    y2: 273.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_37_2710",
    x1: 69705,
    y1: -67656,
    x2: 26196.7,
    y2: -67656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_37_2710",
    x1: -30.6033,
    y1: 250.511,
    x2: -45.4158,
    y2: 250.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D30746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1F5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_37_2710",
    x1: 449.892,
    y1: 267.512,
    x2: 449.892,
    y2: 246.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6C7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_37_2710",
    x1: 257.54,
    y1: 499.459,
    x2: 178.717,
    y2: 499.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71397C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C582D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_37_2710",
    x1: 53954.3,
    y1: -22366500,
    x2: 114033,
    y2: -22366500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_37_2710",
    x1: 35439.6,
    y1: -744316,
    x2: 35439.6,
    y2: -743243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_37_2710",
    x1: 35275.3,
    y1: -110187,
    x2: 47658.4,
    y2: -110187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_37_2710",
    x1: 57.9789,
    y1: 264.867,
    x2: 162.354,
    y2: 264.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_37_2710",
    x1: 9090.46,
    y1: -528471,
    x2: 8833.2,
    y2: -528781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_37_2710",
    x1: 350.762,
    y1: 54.1126,
    x2: 377.666,
    y2: 54.1126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_37_2710",
    x1: 473.301,
    y1: 59.6231,
    x2: 508.386,
    y2: 59.6231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_37_2710",
    x1: 422.334,
    y1: 27.0656,
    x2: 462.866,
    y2: 27.0656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB5B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_37_2710",
    x1: 378.16,
    y1: 9.97739,
    x2: 403.811,
    y2: 9.97739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE42C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AD419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_37_2710",
    x1: 385.76,
    y1: 89.2669,
    x2: 385.76,
    y2: 76.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_37_2710",
    x1: 3925.4,
    y1: -58164.3,
    x2: 3943.95,
    y2: -58556.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_37_2710",
    x1: 373.152,
    y1: 43.895,
    x2: 373.152,
    y2: 57.1368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE42C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AD419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_37_2710",
    x1: 1535.52,
    y1: -4146.35,
    x2: 1535.52,
    y2: -4175.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0072FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_37_2710",
    x1: 329.82,
    y1: 71.8462,
    x2: 329.82,
    y2: 78.1377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_37_2710",
    x1: 1279.22,
    y1: -4687.94,
    x2: 1279.22,
    y2: -4659.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_37_2710",
    x1: 351.166,
    y1: 70.7921,
    x2: 351.166,
    y2: 60.8463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB5B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_37_2710",
    x1: 1603.64,
    y1: -6605.02,
    x2: 1603.64,
    y2: -6640.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB5B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_37_2710",
    x1: 2235.2,
    y1: -21449.3,
    x2: 2235.2,
    y2: -21387.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_37_2710",
    x1: 1219.81,
    y1: -2389.68,
    x2: 1219.81,
    y2: -2408.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB5B3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_37_2710",
    x1: 1912.21,
    y1: -7755.5,
    x2: 1912.21,
    y2: -7717.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE42C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6AD419"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_37_2710",
    x1: 183.392,
    y1: 399.379,
    x2: 183.392,
    y2: 312.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#352961"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_37_2710",
    x1: 15236.3,
    y1: -13370900,
    x2: 8153.47,
    y2: -13375900,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#774181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#352961"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_37_2710",
    x1: 329.146,
    y1: 520.304,
    x2: 238.246,
    y2: 340.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B122E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_37_2710",
    x1: 153.859,
    y1: 427.07,
    x2: 126.099,
    y2: 333.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B122E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B122E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_37_2710",
    x1: 5984.45,
    y1: -2947240,
    x2: 6204.12,
    y2: -2947240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B122E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B122E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_37_2710",
    x1: 649.672,
    y1: 534.97,
    x2: 487.972,
    y2: 494.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2A4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C3DB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_37_2710",
    x1: 573.384,
    y1: -376.953,
    x2: 649.552,
    y2: -378.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#866EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9FEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_37_2710",
    x1: 19791.6,
    y1: -17512700,
    x2: 24628.9,
    y2: -17513300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_37_2710",
    x1: 32011.1,
    y1: -16689100,
    x2: 32011.1,
    y2: -16707700,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_37_2710",
    x1: 13164.5,
    y1: -17197000,
    x2: 12040,
    y2: -17197100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_37_2710",
    x1: 12978.3,
    y1: -584173,
    x2: 13758.5,
    y2: -584173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B122E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpFormPic);
export default __webpack_public_path__ + "static/media/cp-form-pic.9d0077a8272b76325def26b1f9b9bfbd.svg";
export { ForwardRef as ReactComponent };